import { render, staticRenderFns } from "./gc-gauge.vue?vue&type=template&id=1a7c622f"
import script from "./gc-gauge.vue?vue&type=script&lang=js"
export * from "./gc-gauge.vue?vue&type=script&lang=js"
import style0 from "./gc-gauge.vue?vue&type=style&index=0&id=1a7c622f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports